import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider } from '@mui/material/styles'
import {CssBaseline, GlobalStyles} from '@mui/material'
import { theme } from '@/theme/theme'
import App from './App'

const globalStyles = (
    <GlobalStyles
        styles={{
            '*': {
                scrollBehavior: 'smooth',
            },
            html: {
                scrollBehavior: 'smooth',
            },
            body: {
                scrollBehavior: 'smooth',
            },
            '@media (prefers-reduced-motion: reduce)': {
                '*': {
                    scrollBehavior: 'auto',
                },
            },
        }}
    />
)

const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />
          {globalStyles}
        <App />
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
)